import Breadcrumb from '#client/components/common/Breadcrumb/Breadcrumb';

export default function InventoryAdjustmentBreadcrumbs(props) {
    let breadcrumbItems = generateBreadcrumbs(props);

    return <Breadcrumb items={breadcrumbItems} />;
}

const generateBreadcrumbs = (props) => {
    const breadcrumbs = [];
    breadcrumbs.push({ label: 'Inventory Adjustments', url: '/inventory-adjustments' });

    if (props.adjustmentName) {
        breadcrumbs.push({ label: props.adjustmentName });
    }

    return breadcrumbs;
};
